<template>
  <div class="download">

    <div class="banner">
      <img class="b-top" src="../../assets/down-banner-top.png" alt="不木钱包" />
      <div class="content">
        <div class="avader">
          <img src="../../assets/down-phone.png" alt="不木钱包" />
        </div>
        <div class="text">
          <div class="title">
            <div class="image">
              <img src="../../assets/down-app.png" alt="不木钱包" />
            </div>
            <div class="message">
              <h1>不木钱包APP</h1>
              <p>一款有温度的发薪工具</p>
            </div>
          </div>
          <div class="qrcode">
            <div class="code">
              <img src="../../assets/download.png" alt="不木钱包" />
            </div>
            <div class="buttons">
              <button>
                <img src="../../assets/apple.png" alt="不木钱包" />
                <span>iOS下载</span>
              </button>
              <button>
                <img src="../../assets/android.png" alt="不木钱包" />
                <span>Android下载</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <img class="b-btm" src="../../assets/down-banner-btm.png" alt="不木钱包" />
    </div>

    
  </div>
</template>

<script>
import _ from 'lodash';
import Title from '../../components/Title';
import store from '../../store/index'
// import {  } from '../../utils/apis';

export default {
  name: 'Download',
  components: { Title },
  data: function(){
    return{
      menuType: 1,
    }
  },
  computed: {
    
  },
  mounted() {

  },
  methods: {

    
  }
}
</script>
<style lang="scss" scoped>
    .download{
      .banner{
        width: 100%;
        height: 870px;
        background: linear-gradient(159deg, #3179F4 0%, #3AB4FF 100%);
        position: relative;
        .b-top{
          position: absolute;
          width: 1200px;
          top: 0;
          right: 0;
          left: 50%;
          transform: translateX(-50%);
        }
        .b-btm{
          position: absolute;
          width: 100%;
          bottom: 0;
          right: 0;
          left: 0;
          max-height: 100px;
        }
        .content{
          width: 1200px;
          margin: 0 auto;
          padding-top: 150px;
          display: flex;
          justify-content: center;
          .avader{
            width: 372px;
            margin-right: 148px;
            img{
              width: 100%;
            }
          }
          .text{
            padding-top: 150px;
            .title{
              display: flex;
              .image{
                border-radius: 14px;
                background: #fff;
                width: 70px;
                height: 70px;
                padding: 10px;
                img{
                  width: 100%;
                }
              }
              .message{
                margin-left: 20px;
                h1{
                  font-size: 34px;
                  font-weight: 400;
                  color: #fff;
                }
                p{
                  font-size: 16px;
                  font-weight: 400;
                  color: #fff;
                  letter-spacing: 4px;
                }
              }
            }
            .qrcode{
              margin-top: 70px;
              display: flex;
              .code{
                width: 150px;
                height: 150px;
                img{
                  width: 100%;
                }
              }
              .buttons{
                width: 200px;
                margin-left: 22px;
                button{
                  width:200px;
                  height:60px;
                  background:rgba(255,255,255,.7);
                  border-radius:30px;
                  margin-bottom: 20px;
                  border: none;
                  cursor: pointer;
                  &:hover{
                    opacity: .8;
                  }
                  img{
                    width: 24px;
                    vertical-align: middle;
                  }
                  span{
                    font-size: 16px;
                    color: #333;
                    font-weight: 400;
                    vertical-align: middle;
                    margin-left: 12px;
                  }
                }
              }
            }
          }
        }
      }
     
    }
    
</style>
